import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'What is The Freelance Proposal Machine™?',
  a: "It's a six-volume digital system containing structured AI prompts and workflows to help freelancers organize client briefs, define project scope, prepare proposals, review their work, and plan the client handoff."
}, {
  q: 'Do I need to be an AI expert?',
  a: 'No. The prompts include customization fields and practical instructions. You provide the relevant project information, review the output, and adapt it to your needs.'
}, {
  q: 'Which AI tools can I use?',
  a: 'You can use the prompts with compatible AI assistants that accept written instructions, including ChatGPT, Claude, Gemini, and similar tools. Features and results may vary by platform and subscription plan.'
}, {
  q: 'Is it suitable for different freelance professions?',
  a: 'The workflow is designed to be adaptable to different freelance services, including design, development, writing, consulting, marketing, and virtual assistance.'
}, {
  q: 'Does the system automatically create a finished proposal?',
  a: 'The prompts can help you organize information and draft proposal sections. You remain responsible for reviewing, correcting, and approving the final document.'
}, {
  q: 'Is this a physical book?',
  a: 'No. The Freelance Proposal Machine™ is a digital product supplied in PDF format.'
}, {
  q: 'Do I receive all five bonuses?',
  a: 'Yes. Your package includes all five listed bonus resources alongside the six-volume main system.'
}, {
  q: 'Is this a one-time payment?',
  a: 'Yes. The advertised price is a one-time payment of $27 USD for the digital package, with no recurring subscription for this purchase.'
}, {
  q: "What if I'm not satisfied?",
  a: 'Your purchase is covered by a 7-day money-back guarantee. Contact support within 7 days of purchase to request a refund under the applicable refund policy.'
}, {
  q: 'Does the system guarantee that I will win more clients?',
  a: 'No specific number of clients or sales outcomes is guaranteed. The system is designed to help you prepare more structured proposals, define project scope more clearly, and communicate your work professionally. Results depend on your services, experience, pricing, client fit, and how you apply the material.'
}, {
  q: 'How do I get access?',
  a: 'After completing your purchase, follow the access instructions provided by the checkout platform to obtain your digital materials.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-white" data-id="element-35" data-mp="2umhslr91y5gz">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "21px",
      paddingBottom: "17px"
    }} data-id="element-36" data-mp="1n7wmnppl18iz">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-37" data-mp="1j61mioje116s">❓ Frequently asked questions</h2>
        <div className="mt-10 divide-y divide-plum/10 overflow-hidden rounded-2xl border border-plum/15 bg-white" data-id="element-38" data-mp="3uuy04id3orqr">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-39" data-mp="7oypkfn4wlit" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-40" data-mp="7nnmyj5fdjta">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-41" data-mp="mcs3zx0hhhzt">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-42" data-mp="qgzunzqi580o" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-43" data-mp="veja32yxrqu7" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-44" data-mp="2s731hzlma7q3">
                  <div className="overflow-hidden" data-id="element-45" data-mp="2x6eh35a8z763">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-46" data-mp="21vg9m75iy9lu">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}